import Axios from '@/api/http'
/**
 * 获取组织空间左侧导航信息
 * */
export function getorgmenu(date) {
  return Axios({
    method: 'post',
    url: '/openapi/getorgmenu',
    data: date,
  })
}

/**
 * 查看组织空间是否打开
 * */
export function getschool(date) {
  return Axios({
    method: 'post',
    url: '/api/getschool',
    data: date,
  })
}
/**
 * 获取空间信息
 * */
export function getschoolconfigs(date) {
  return Axios({
    method: 'post',
    url: '/api/getschoolconfigs',
    data: date,
  })
}

/**
 * 开启或关闭组织空间
 * */
export function updateschool(date) {
  return Axios({
    method: 'post',
    url: '/api/updateschool',
    data: date,
  })
}

/**
 * 开启或关闭标签空间管理
 * */
export function updatedepttippower(date) {
  return Axios({
    method: 'post',
    url: '/api/updatedepttippower',
    data: date,
  })
}

/**
 * 获取功能设置组织标签列表
 * */
export function getspacedepttiplist(date) {
  return Axios({
    method: 'post',
    url: '/api/getspacedepttiplist',
    data: date,
  })
}

/**
 * 修改组织标签开关
 * */
export function updatedepttip(date) {
  return Axios({
    method: 'post',
    url: '/api/updatedepttip',
    data: date,
  })
}
/**
 * 根据空间id获取对应空间信息
 * */
export function getorganization(date) {
  return Axios({
    method: 'post',
    url: '/openapi/getorgmenu',
    data: date,
  })
}
/**
 * 根据空间id修改对应空间信息
 * */
export function updateorganization(date) {
  return Axios({
    method: 'post',
    url: '/api/updateorganization',
    data: date,
  })
}
/**
 * 修改组织排序
 * */
export function updateorgorders(date) {
  return Axios({
    method: 'post',
    url: '/api/updateorgorders',
    data: date,
  })
}
/**
 * 修改组织内成员排序
 * */
export function updateuserorders(date) {
  return Axios({
    method: 'post',
    url: '/api/updateuserorders',
    data: date,
  })
}
/**
 * 根据空间id修改对应空间信息
 * */
export function getspaceusernum(date) {
  return Axios({
    method: 'post',
    url: '/api/getspaceusernum',
    data: date,
  })
}

/**
 * 修改个人标签开关
 * */
export function updateusertip(date) {
  return Axios({
    method: 'post',
    url: '/api/updateusertip',
    data: date,
  })
}

/**
 * 获取个人空间开关
 * */
export function isopenupace(date) {
  return Axios({
    method: 'post',
    url: '/openapi/isopenupace',
    data: date,
  })
}

/**
 * 获取个人空间左侧导航信息
 * */
export function getuspacemenu(date) {
  return Axios({
    method: 'post',
    url: '/openapi/getuspacemenu',
    data: date,
  })
}

/**
 * 获取个人空间空间信息
 * */
export function getupacemsg(date) {
  return Axios({
    method: 'post',
    url: '/api/getupacemsg',
    data: date,
  })
}

/**
 * 修改个人空间空间信息
 * */
export function updateupacemsg(date) {
  return Axios({
    method: 'post',
    url: '/api/updateupacemsg',
    data: date,
  })
}

/**
 * 获取个人空间用户信息列表
 * */
export function getupacecountlist(date) {
  return Axios({
    method: 'post',
    url: '/api/getupacecountlist',
    data: date,
  })
}
  /**
   * 批量新增年级
   * **/
export function addnianduan(data) {
    return Axios({
      url: '/api/addnianduan',
      method: 'post',
      data: data
    })
  }
  /**
   * 批量新增班级
   * **/
export function addbanji (data) {
    return Axios({
      url: '/api/addbanji',
      method: 'post',
      data: data
    })
}